export default __webpack_public_path__ + "static/media/card-hand.5eb6a5b9.png";